import { Paper, Title } from '@mantine/core';

const DioceseInfo = () => {
  return (
    <Paper p="xl" radius="md" w="100%">
      <Title order={3}>Diocese Info</Title>
      <p>Diocese Info content will be implemented here.</p>
    </Paper>
  );
};

export default DioceseInfo;
